export const FILTER_CONFIG = {
  myTeamPatients: {
    selectedClinician: true,
    scheduledCallStatus: true,
    preferredLanguage: true,
    orgId: true,
    locationId: true,
    providerId: true,
    urgentType: true,
    apcmEnrollment: true,
    rpmAddonStatusId: true,
    callAttempts: true,
    completedChecked: true,
  },
  urgentdischargemanagement: {
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    preferredLanguage: true,
    orgId: true,
    locationId: true,
    providerId: true,
  },
  mypatients: {
    scheduledCallStatus: true,
    preferredLanguage: true,
    orgId: true,
    locationId: true,
    providerId: true,
    callAttempts: true,
    apcmEnrollment: true,
    rpmAddonStatusId: true,
    urgentType: true,
    completedChecked: true,
  },
  myteampatients: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    selectedClinician: true,
    scheduledCallStatus: true,
    callAttempts: true,
    apcmEnrollment: true,
    rpmAddonStatusId: true,
    urgentType: true,
    completedChecked: true,
  },
  records: {
    showOnlyCallAttempts: true,
  },
  urgenttriage: {
    selectedTeam: true,
    selectedClinician: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentitmedicalrecord: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
  },
  urgentnurse: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
  },
  urgentrefill: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
  },
  urgentlead: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
  },
  urgentappointment: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
  },
  urgentpreenrollment: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
  },
  urgentmips: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
    callAttempts: true,
  },
  urgentcareplan: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    selectedTeam: true,
    selectedClinician: true,
    scheduledCallStatus: true,
  },
  urgentaccount: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    programType: true,
    scheduledCallStatus: true,
  },
  unverified: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    scheduledCallStatus: true,
    reEngageFiltering: true,
  },
  apcmunverified: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    scheduledCallStatus: true,
    reEngageFiltering: true,
    selectedEligibilityLevel: true,
  },
  rpmunverified: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
    scheduledCallStatus: true,
    reEngageFiltering: true,
    selectedEligibilityLevel: true,
    programType: true,
    selectedRpmDeviceTypeId: true,
  },
  optout: {
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentrequestedinfo: {
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentcallback: {
    programType: true,
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentcopay: {
    programType: true,
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentproviderchange: {
    programType: true,
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentroundtwo: {
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentpoa: {
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentbadphone: {
    programType: true,
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  urgentcne: {
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  patientservices: {
    programType: true,
    preferredLanguage: true,
  },
  patientservicesopencharts: {},
  urgentnoanswer: {
    programType: true,
    scheduledCallStatus: true,
    orgId: true,
    preferredLanguage: true,
    locationId: true,
    providerId: true,
  },
  rpmthresholdalerts: {
    orgId: true,
    selectedRpmDeviceTypeId: true,
    selectedRpmAlertSeverityId: true,
  },
};
